<template>
  <div class="modal-overlay">
    <div class="card" @click.stop>
      <div class="card-header">
        <i class="fa fa-deaf text-primary me-2" />{{
          props.allergy.id != null ? "Edit Allergy" : "New Allergy"
        }}
      </div>
      <hr class="horizontal dark m-0" />

      <el-form
        ref="allergyFormRef"
        :model="allergyForm"
        :rules="rules"
        label-width="120px"
        size=""
        status-icon
        :scroll-to-error="true"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <div class="card-body">
          <div class="mb-3">
            <el-form-item label="Allegy Name" prop="name">
              <el-input v-model="allergyForm.name" />
            </el-form-item>
          </div>

          <div class="mb-3">
            <el-form-item label="Description" prop="description">
              <el-input v-model="allergyForm.description" type="textarea" />
            </el-form-item>
          </div>
        </div>
        <div class="card--footer">
          <button
            class="btn mb-0 btn-danger btn-xs"
            @click="$emit('close-modal')"
          >
            Cancel
          </button>
          <el-button
            type="success"
            :loading="isLoading"
            @click="submitForm(allergyFormRef)"
            >Submit</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="close bg-danger" @click="$emit('close-modal')">
      <i class="fa fa-times" />
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { createAllergy, updateAllergy } from "../../api/services/services";
import { ElNotification } from "element-plus";
const allergyFormRef = ref();
const isLoading = ref(false);
export default {
  name: "add-allergy",

  props: {
    allergy: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    
    const allergyForm = reactive({
      id: props?.allergy?.id || 0,
      name: props?.allergy?.name || "",
      description: props?.allergy?.description || "",
    });

    const rules = reactive({
      name: [
        {
          required: true,
          message: "Please input allergy name",
          trigger: ["blur", "change"],
        },
      ],

      description: [
        {
          required: true,
          message: "Please input a description",
          trigger: ["blur", "change"],
        },
      ],
    });

    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          isLoading.value = true;
          const formData = new FormData();

          formData.append("name", allergyForm.name);
          formData.append("description", allergyForm.description);
          if (allergyForm.id > 0) {
            updateAllergy(allergyForm)
              .then((data) => {
                if (data.success) {
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });
                  emit("refresh-allergies");
                  emit("close-modal");
                } else {
                  if (data.errors) {
                    Object.values(data.errors).forEach((val) =>
                      ElNotification({
                        title: "Error",
                        message: val[0],
                        type: "error",
                      })
                    );
                  }
                  if (data.message) {
                    ElNotification({
                      title: "Error",
                      message: data.message,
                      type: "error",
                    });
                  }
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          } else {
            createAllergy(formData)
              .then((data) => {
                if (data.success) {
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });
                  emit("refresh-allergies");
                  emit("close-modal");
                } else {
                  if (data.errors) {
                    Object.values(data.errors).forEach((val) =>
                      ElNotification({
                        title: "Error",
                        message: val[0],
                        type: "error",
                      })
                    );
                  }
                  if (data.message) {
                    ElNotification({
                      title: "Error",
                      message: data.message,
                      type: "error",
                    });
                  }
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    return {
      submitForm,
      rules,
      allergyForm,
      allergyFormRef,
      isLoading,
      props,
    };
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.card {
  margin-top: 5%;
  outline: 0;
  border-radius: 7px;
  width: 450px;
  height: 450px;
  box-shadow: 0 10px 20px -8px rgba(0, 0, 0, 0.15);
}

.card-body {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}

.card-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.2rem !important;
}

.card--footer {
  display: flex;
  justify-content: space-between;
  padding: 0 1.2rem 1.2rem 1.2rem !important;
}

.close {
  margin: 5% 0 0 10px;
  cursor: pointer;
  color: #fff;
  border: 2px solid #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}

input {
  border-radius: 6px;
}
</style>
